import { useEffect, useState } from "react";

const useWidgetLoadTracker = (props) => {
  const { trackOnLoad, contentLoaded, remote, remoteData } = props
  const [isTracked, setIsTracked] = useState(false);

  useEffect(() => {
    if (trackOnLoad && !isTracked && remote && contentLoaded) {
      // This sends tracking events for widgets whose content is fetched from remote
      ChrAnalytics.trackEvent(remoteData.trackingOptions.name, remoteData.trackingOptions);
      setIsTracked(true);
    }
  }, [isTracked, contentLoaded]);
}

export default useWidgetLoadTracker